// extracted by mini-css-extract-plugin
export default {"screenReaderOnly":"eh0ik"};